// KWANKGM04040_借入申込入力（受付完了）
import React from 'react';
import TopArea from '../../molecules/TopArea';
import { StepNavigation as StepType } from '../../types/Template';
import LoadingModal from '../../molecules/LoadingModal';
import ExaminationCompleteBody from './ExaminationCompleteBody';
import MypageReturn from '../../molecules/MypageReturn';

interface Props {
  step_navigation: StepType;
  reception_cd: string;
  label: string;
  status_name: string;
  display_reception_cd: boolean;
  guide_text: string;
  is_loading: boolean;
  guarantors_num: number;
  display_status: boolean;
  is_change: boolean;
}

const ExaminationComplete: React.FC<Props> = ({
  step_navigation,
  reception_cd,
  label,
  status_name,
  display_reception_cd,
  guide_text,
  is_loading,
  guarantors_num,
  display_status,
  is_change,
}) => {
  return (
    <>
      <TopArea
        step_navigation={step_navigation}
        reception_cd={reception_cd}
        label={label}
        status_name={status_name}
        display_reception_cd={display_reception_cd}
        guide_text={guide_text}
        display_status={display_status}
      />
      <ExaminationCompleteBody
        reception_cd={reception_cd}
        is_decline={false}
        is_change={is_change}
        guarantors_num={guarantors_num}
      />
      <MypageReturn is_staff={false} />
      <LoadingModal show={is_loading} />
    </>
  );
};

export default ExaminationComplete;